import React from 'react';
import LegalPage from './LegalPage';
import LegalDocument from '../../legal/LegalDocument';
import { TERMS } from '../../legal/documents';

const Terms: React.FC = () => (
  <LegalPage title="Пользовательское соглашение">
    <LegalDocument nodes={TERMS} />
  </LegalPage>
);

export default Terms;
